<template>
  <div>
    <q-slide-item
      v-for="payment in payments"
      :key="payment.id"
      right-color="negative"
      :disable="disable"
      class="bg-responsive"
      @right="$emit('remove-payment', payment)"
      @click="$emit('edit-payment', payment)"
    >
      <template
        v-if="draftOrPreAuth(payment.state) && !disable"
        #right
      >
        <q-icon
          left
          name="delete"
        />
        Remove
      </template>
      <q-item
        class="row"
        :class="colorForState(payment.state)"
      >
        <q-item-section
          class="col-grow"
          style="max-width: 87%"
        >
          <q-item-label
            overline
            class="text-uppercase"
          >
            {{ payment.details }}
          </q-item-label>
        </q-item-section>
        <q-item-section
          v-if="payment.state === 'completed'"
          class="col-auto"
        >
          <q-icon
            name="lock"
            color="grey"
          />
        </q-item-section>
        <q-item-section
          v-if="payment.state === 'canceled'"
          class="col-auto"
        >
          <q-icon
            name="error"
            color="negative"
            size="sm"
          />
          <q-tooltip class="bg-red-3 text-negative">
            {{ payment.paymentConnectorResponseMessage || payment.stripeFailureMessage }}
          </q-tooltip>
        </q-item-section>
        <q-item-section class="col-auto">
          <i18n-n
            v-if="payment.type === 'cash'"
            :value="payment.finalCashReceived"
            format="currency"
            scope="global"
          />
          <i18n-n
            v-else
            :value="payment.amount"
            format="currency"
            scope="global"
          />
        </q-item-section>
      </q-item>
    </q-slide-item>
  </div>
</template>

<script>
import { PAYMENT_STATES } from 'src/models/payment/Payment'

export default {
  name: 'PaymentSlideItems',
  props: {
    payments: {
      type: Array,
      required: true
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['remove-payment', 'edit-payment'],
  methods: {
    colorForState (state) {
      if (state === 'completed') return 'bg-responsive-grey-4'
      if (state === 'canceled') return 'bg-orange-3'
      return 'white'
    },
    draftOrPreAuth (state) {
      return state === PAYMENT_STATES.DRAFT || state === PAYMENT_STATES.PRE_AUTH
    }
  }
}
</script>
